module.exports = __webpack_public_path__ + "img/icon-basicEduS-1.6f04a355.png";